// extracted by mini-css-extract-plugin
export default {"home":"Toast_home__aiAGF","region":"Toast_region__ceMqY","toast":"Toast_toast__mbXKE","action":"Toast_action__EkwdD","danger":"Toast_danger__M9OwH"};